import { BUTTON_TYPES } from 'constant';
import Image from 'next/image';
import { AfterMarketPartResult } from '@/types/api';
import useCart from '@/hooks/cart';

import PriceBox from '../PriceBox';
import Button from '../Button';

export default function AfterMarketOptions({
  afterMarketParts,
  setIsAddingToCart,
  isAddingToCart,
}: {
  afterMarketParts: AfterMarketPartResult;
  setIsAddingToCart: any;
  isAddingToCart: any;
}) {
  const { addItemToCart } = useCart();

  return (
    <div>
      <div className="text-brand-100 text-xl font-medium mb-2">
        Aftermarket Options
      </div>
      <div className="text-base text-[#5A5A5A]">
        Discover alternative aftermarket parts from trusted manufacturers at a
        reasonable price.
      </div>
      <div>
        {afterMarketParts.length ? (
          afterMarketParts.map(
            ({
              photo,
              manufacturerCode,
              manufacturerName,
              partName,
              partNumber,
              price,
            }) => (
              <div
                className="flex bg-brand-600 rounded-md my-3"
                key={manufacturerCode}
              >
                <div className="p-2 pr-0">
                  <div className="bg-white rounded-lg h-full w-full items-center flex min-h-[130px]">
                    <a target="_blank" href={photo} rel="noopener noreferrer">
                      <Image
                        src={photo}
                        className="max-w-[150px]"
                        alt={`${manufacturerName} part for ${partNumber}`}
                        width={200}
                        height={135}
                      />
                    </a>
                  </div>
                </div>
                <div className="flex flex-col grow p-4">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between">
                    <div>
                      <span className="text-sm font-bold text-gold-100">
                        {manufacturerName}
                      </span>{' '}
                      <span className="text-sm font-medium">
                        {manufacturerCode}
                      </span>
                    </div>
                    <div className="text-sm font-bold">{partNumber}</div>
                  </div>

                  <div className="text-md grow mt-2">{partName}</div>
                  <div className="sm:flex justify-between items-center mt-2">
                    <PriceBox price={price} priceStyle="text-xl" />
                    <Button
                      className="w-[110px] min-h-[38px] text-xs p-0 self-end mt-2 sm:mt-0"
                      type={BUTTON_TYPES.FILLED}
                      loaderSize="small"
                      onClick={() => {
                        setIsAddingToCart(true);
                        addItemToCart(
                          'afterMarketPart',
                          1,
                          `${partNumber}@${manufacturerCode}`,
                        );
                      }}
                      loading={isAddingToCart}
                    >
                      Add to cart
                    </Button>
                  </div>
                </div>
              </div>
            ),
          )
        ) : (
          <div className="bg-brand-600 p-4 my-3 text-lg">
            No options found in our websites database. Contact us directly, at{' '}
            <a
              rel="noopener noreferrer"
              target="_blank"
              className="underline"
              href="mailto:parts@oemstock.co.uk"
            >
              parts@oemstock.co.uk
            </a>{' '}
            to check for availability.
          </div>
        )}
      </div>
    </div>
  );
}
